"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const enhancers_1 = require("./enhancers");
const enhance_props_1 = __importDefault(require("./enhance-props"));
const Box = (_a) => {
    var { is = 'div', innerRef, children } = _a, props = __rest(_a, ["is", "innerRef", "children"]);
    // Convert the CSS props to class names (and inject the styles)
    const { className, enhancedProps: parsedProps } = enhance_props_1.default(props);
    parsedProps.className = className;
    if (innerRef) {
        parsedProps.ref = innerRef;
    }
    return react_1.default.createElement(is, parsedProps, children);
};
Box.displayName = 'Box';
Box.propTypes = Object.assign({}, enhancers_1.propTypes, { innerRef: prop_types_1.default.oneOfType([
        prop_types_1.default.func,
        prop_types_1.default.shape({ current: prop_types_1.default.element })
    ]), is: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.func]) });
Box.defaultProps = {
    innerRef: null,
    is: 'div',
    boxSizing: 'border-box'
};
exports.default = Box;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm94LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFBQSxrREFBeUI7QUFDekIsNERBQWtDO0FBRWxDLDJDQUFxQztBQUNyQyxvRUFBMEM7QUFFMUMsTUFBTSxHQUFHLEdBQWlCLENBQUMsRUFBNEMsRUFBRSxFQUFFO1FBQWhELEVBQUUsRUFBRSxHQUFHLEtBQUssRUFBRSxRQUFRLEVBQUUsUUFBUSxPQUFZLEVBQVYsa0RBQVE7SUFDbkUsK0RBQStEO0lBQy9ELE1BQU0sRUFBQyxTQUFTLEVBQUUsYUFBYSxFQUFFLFdBQVcsRUFBQyxHQUFHLHVCQUFZLENBQUMsS0FBSyxDQUFDLENBQUE7SUFFbkUsV0FBVyxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUE7SUFFakMsSUFBSSxRQUFRLEVBQUU7UUFDWixXQUFXLENBQUMsR0FBRyxHQUFHLFFBQVEsQ0FBQTtLQUMzQjtJQUVELE9BQU8sZUFBSyxDQUFDLGFBQWEsQ0FBQyxFQUFFLEVBQUUsV0FBVyxFQUFFLFFBQVEsQ0FBQyxDQUFBO0FBQ3ZELENBQUMsQ0FBQTtBQUVELEdBQUcsQ0FBQyxXQUFXLEdBQUcsS0FBSyxDQUFBO0FBRXZCLEdBQUcsQ0FBQyxTQUFTLHFCQUNSLHFCQUFTLElBQ1osUUFBUSxFQUFFLG9CQUFTLENBQUMsU0FBUyxDQUFDO1FBQzVCLG9CQUFTLENBQUMsSUFBSTtRQUNkLG9CQUFTLENBQUMsS0FBSyxDQUFDLEVBQUUsT0FBTyxFQUFFLG9CQUFTLENBQUMsT0FBTyxFQUFFLENBQUM7S0FDaEQsQ0FBQyxFQUNGLEVBQUUsRUFBRSxvQkFBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLG9CQUFTLENBQUMsTUFBTSxFQUFFLG9CQUFTLENBQUMsSUFBSSxDQUFDLENBQUMsR0FDNUQsQ0FBQTtBQUVELEdBQUcsQ0FBQyxZQUFZLEdBQUc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxFQUFFLEVBQUUsS0FBSztJQUNULFNBQVMsRUFBRSxZQUFZO0NBQ3hCLENBQUE7QUFFRCxrQkFBZSxHQUFHLENBQUEifQ==